<template>
  <div class="bg-white px2-pc px1-mobile pb-1">
    <div class="backlink mt3-pc">
      <a
        layout="row"
        layout-align="start center"
        @click="back"
      >
        <v-icon
          class="mr-1"
          color="grey"
        >mdi-chevron-left</v-icon>{{ $t('circles.back') }}
      </a>
    </div>
    <div
      layout="row"
      layout-align="start center"
      class="title grey--text text-uppercase font-weight-medium mb-2 mt3-pc mt1-mobile"
    >{{isNew ? $t('circles.new') : $t('circles.edit')}}</div>

    <v-form
      v-if="!loading"
      class="mt5-pc mt3-mobile"
      layout="column"
      layout-align="center center"
      ref="form"
      v-model="formValid"
      @submit.prevent="save"
    >
      <div class="width-95-mobile">
        <v-text-field
          v-model="circle.name"
          class="field-width"
          :label="$t('circles.name')+' *'"
          :rules="[ v => !!v || $t('errors.required') ]"
        ></v-text-field>
      </div>
      <div class="width-95-mobile">
        <v-textarea
          v-model="circle.description"
          class="field-width"
          :label="$t('circles.description')+' *'"
          :rules="[ v => !!v || $t('errors.required') ]"
        ></v-textarea>
      </div>
      <div class="width-95-mobile">
        <v-checkbox
          v-model="circle.is_private"
          :false-value="0"
          :true-value="1"
          :label="$t('circles.is_private')"
          :hint="$t('circles.hint_private')"
          persistent-hint
          class="field-width"
        ></v-checkbox>
      </div>
      <div class="width-95-mobile">
        <v-subheader class="form-subhead mt-3">{{$t('circles.members')}}</v-subheader>
        <div class="search-bar">
          <v-menu
            v-model="searching"
            offset-y
            bottom
            full-width
            max-height="225"
            class="field-width"
          >
            <v-text-field
              v-model="search"
              :label="$t('circles.search_members')"
              :hide-no-data="(!search || search.length < 3) ? true : false"
              hide-details
              return-object
              :loading="loading2"
              prepend-icon="mdi-magnify"
              slot="activator"
            ></v-text-field>
            <v-list
              v-if="items && items.length"
              class="search-list"
            >
              <v-list-tile
                v-for="(item, index) in items"
                :key="index"
                @click="handleSelect(item)"
                class="search-item"
              >
                <div
                  layout="row"
                  layout-align="start center"
                  class="body-1"
                  style="color: black"
                >
                  <avatar
                    :fullname="item.firstname + ' ' + item.lastname"
                    :image="getImageData(item.id)"
                    class="mr-2"
                    size="18"
                  ></avatar>
                  <div layout="column">
                    <div
                      layout="row"
                      layout-align="start center"
                    >
                      <b>{{item.firstname}} {{item.lastname}}</b>
                      <v-chip
                        label
                        :color="levelColor(item.level)"
                        class="text-lowercase ml-1"
                        text-color="white"
                        style="width: fit-content; height: 16px; font-size: 10px;"
                        small
                      >
                        {{levelLabel(item.level)}}
                      </v-chip>
                    </div>
                    {{item.school.name}}
                  </div>
                </div>
              </v-list-tile>
            </v-list>
            <div
              v-else-if="!loading2 && search && search.length > 2"
              class="text-xs-center py-2"
            >
              <em>{{$t('_.no_result')}}</em>
            </div>
          </v-menu>
        </div>
        <div
          layout="row"
          layout-align="end center"
          class="field-width"
        >
          <v-text-field
            v-model="searchData"
            append-icon="search"
            :label="$t('circles.search_member')"
            single-line
            hide-details
            style="max-width: 300px"
          ></v-text-field>
        </div>
        <v-data-table
          :headers="headers"
          :items="circle.users"
          :pagination.sync="pagination"
          :search="searchData"
          class="field-width"
        >
          <template
            slot="items"
            slot-scope="{ item }"
          >
            <td>{{ item.firstname }}</td>
            <td>{{ item.lastname }}</td>
            <td>{{ levelLabel(item.level) }}</td>
            <td>{{ item.school ? item.school.name : '-' }}</td>
            <td>
              <v-btn
                @click="removeMember(item)"
                icon
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </div>
      <div
        layout="row"
        layout-align="end center"
        class="field-width width-95-mobile mt-2 mb-2"
      >
        <v-btn
          depressed
          color="secondary"
          @click="save"
          style="text-transform: none"
        >{{$t('_.save')}}</v-btn>
        &nbsp;{{$t('_.or')}}&nbsp;
        <a
          @click.prevent="back"
          href="#"
          class="grey--text"
        >{{$t('_.cancel')}}</a>
      </div>
    </v-form>
    <div
      layout="row"
      style="height: 100%"
      layout-align="center center"
      v-else
    >
      <v-progress-circular
        indeterminate
        color="secondary"
        size="64"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import Circles from '@/api/circles'
import Representatives from '@/api/representatives'
import I18nMixin from '@/mixins/i18n'
import ImageMixin from '@/mixins/image'
import Avatar from "@/components/shared/Avatar"
import Consts from '@/consts'
import Auth from "@/plugins/auth"

export default {
  components: { Avatar },
  mixins: [I18nMixin, ImageMixin],
  data () {
    return {
      circle: {
        users: [],
        users_ids: []
      },
      formValid: false,
      users: [],
      loading: false,
      loading2: false,
      imgs: {},
      imgsLoad: {},
      search: '',
      search2: '',
      searchData: '',
      items: [],
      searching: false,
      pagination: {
        rowsPerPage: 10,
        descending: 0,
        sortBy: 'firstname',
      },
    }
  },
  mounted () {
    if (!this.isNew) {
      this.fetch()
    }
  },
  watch: {
    search (val) {
      val && val !== this.querySearchAsync(val)
    },
  },
  methods: {
    fetch () {
      this.loading = true
      Circles.get(this.$route.params.id).then(res => {
        this.circle = res.data
        this.loading = false

        if (this.circle.creator_id !== Auth.user.id) {
          this.$router.push({ name: 'my-wall' })
        }
      })
    },
    save () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.loading = true

      if (this.isNew) {
        Circles.create(this.circle).then((res) => {
          this.loading = false
          this.$store.commit("LOAD_CIRCLES", true)
          this.$router.push({ name: 'circles-show', params: { id: res.data.id } })
          this.$snotify.success(this.$t('circles.created'))
        }, () => {
          this.loading = false
        })
      } else {
        Circles.update(this.circle.id, this.circle).then(() => {
          this.loading = false
          this.$store.commit("LOAD_CIRCLES", true)
          this.$router.push({ name: 'circles-show', params: { id: this.circle.id } })
          this.$snotify.success(this.$t('circles.edited'))
        }, () => {
          this.loading = false
        })
      }
    },
    back () {
      if (!this.isNew) {
        this.$router.push({ name: 'circles-show', params: { id: this.$route.params.id } })
      } else {
        this.$router.push({ name: 'circles-index' })
      }
    },
    querySearchAsync (queryString) {
      if (!queryString || queryString.length < 3) {
        return
      }

      this.loading2 = true
      this.searching = true

      // cancel pending call
      clearTimeout(this._timerId)

      // delay new call 350ms
      this._timerId = setTimeout(() => {
        Representatives.getList({ keywords: queryString }).then(res => {
          this.items = res.data

          for (let i = 0; i < this.items.length; i++) {
            const u = this.items[i]
            if (u.avatar_id) {
              this.getImage('/assets/users/' + u.id, u.id)
            }
          }

          this.loading2 = false
          this.search2 = queryString
        })
      }, 350)
    },
    handleSelect (val) {
      if (!val) {
        return
      }
      if (this.circle.users_ids.indexOf(val.id) > -1) {
        this.$snotify.error(this.$t('circles.already_member'))
        return
      }
      this.circle.users_ids.unshift(val.id)
      this.circle.users.unshift(val)
      this.search = ''
      this.search2 = ''
      this.items = []
    },
    removeMember (u) {
      const i = this.circle.users_ids.indexOf(u.id)
      if (i > -1) {
        this.circle.users_ids.splice(i, 1)
        this.circle.users.splice(i, 1)
      }
    },
    levelLabel (l) {
      switch (l) {
        case Consts.MINISTRY:
          return this.$t('users.lv_min')
        case Consts.NATIONAL:
          return this.$t('users.lv_nat')
        case Consts.SECTORAL:
          return this.$t('users.lv_sec')
        case Consts.LOCAL:
          return this.$t('users.lv_loc')
      }
    },
    levelColor (l) {
      switch (l) {
        case Consts.MINISTRY:
          return 'primary'
        case Consts.NATIONAL:
          return 'pink'
        case Consts.SECTORAL:
          return 'secondary'
        case Consts.LOCAL:
          return 'brown'
      }
    },
  },
  computed: {
    isNew () {
      return this.$route.params.id === 'new'
    },
    headers () {
      return [
        { text: this.$t('users.firstname'), value: 'firstname' },
        { text: this.$t('users.lastname'), value: 'lastname' },
        { text: this.$t('params.level'), value: 'level' },
        { text: this.$t('representatives.school'), value: 'school.name' },
        { text: this.$t('_.actions'), sortable: false, width: '60px' },
      ]
    },
  }
}
</script>
<style>
.search-menu > .v-select-list > .v-list > div:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.05);
}
.search-menu > .v-select-list > .v-list > div > a {
  height: 55px;
}
.search-list > div:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.05);
}
.search-item > a {
  height: 55px;
}
</style>